import { render, staticRenderFns } from "./AdsBuyRent.vue?vue&type=template&id=48f1b5f4"
import script from "./AdsBuyRent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdsBuyRent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports